<script>
import { mapGetters } from 'vuex';

export default {
  emits: ['openNotificationPanel'],

  props: {
    // When provided, the bell navigates directly via router-link.
    // When null, it falls back to emitting to open the modal.
    to: {
      type: [String, Object],
      default: null,
    },
  },

  computed: {
    ...mapGetters({
      notificationMetadata: 'notifications/getMeta',
    }),
    unreadCount() {
      if (!this.notificationMetadata.unreadCount) {
        return '';
      }

      return this.notificationMetadata.unreadCount < 100
        ? `${this.notificationMetadata.unreadCount}`
        : '99+';
    },
    isNotificationPanelActive() {
      return this.$route.name === 'notifications_index';
    },
  },
  methods: {
    openNotificationPanel() {
      if (this.$route.name !== 'notifications_index') {
        this.$emit('openNotificationPanel');
      }
    },
  },
};
</script>

<template>
  <div class="">
    <router-link
      v-if="to"
      :to="to"
      class="relative flex items-center justify-center size-10 p-0 rounded-lg transition-colors duration-150"
      :class="[
        isNotificationPanelActive
          ? 'bg-hilab text-white hover:bg-hilab hover:text-white'
          : 'text-n-slate-11 dark:text-n-slate-11 hover:!bg-n-solid-3 dark:hover:!bg-n-solid-3 hover:text-n-slate-12'
      ]"
    >
      <fluent-icon
        icon="alert"
        class="size-6"
        :class="{
          'text-white': isNotificationPanelActive,
        }"
      />
      <span
        v-if="unreadCount"
        class="absolute top-2.5 right-2.5 size-[7px] rounded-full bg-grass-500"
      />
    </router-link>

    <button
      v-else
      class="relative flex items-center justify-center size-10 p-0 rounded-lg transition-colors duration-150"
      :class="[
        isNotificationPanelActive
          ? 'bg-hilab text-white hover:bg-hilab hover:text-white'
          : 'text-n-slate-11 dark:text-n-slate-11 hover:!bg-n-solid-3 dark:hover:!bg-n-solid-3 hover:text-n-slate-12'
      ]"
      @click="openNotificationPanel"
      v-tooltip.right="$t(`SIDEBAR.NOTIFICATIONS`)"
    >
      <fluent-icon
        icon="alert"
        class="size-6"
        :class="{
          'text-white': isNotificationPanelActive,
        }"
      />
      <span
        v-if="unreadCount"
        class="absolute top-2.5 right-2.5 size-[7px] rounded-full bg-grass-500"
      />
    </button>
  </div>
</template>
